<!-- 全部订单 -->
<template>
    <div class="business-content-main">
        <div class="order-list">
            <div class="order-item" :key="index" v-for="(item, index) in orderList">
                <div class="div-table-row">
                    <div class="div-table-cell order-num" style="width: 100%; line-height: 46px">
                        <div>
                            <span class="order-time">{{ item.CreateTime }}</span>
                            <span>订单号：{{ item.Osn }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <template>
                        <div class="div-table-row">
                            <div class="div-table-cell" style="width: 40%; min-width: 400px">
                                <div class="order-msg" v-bind:key="index" v-for="(goods, index) in item.GoodsList">
                                    <template>
                                        <div>
                                            <div class="goods-ctn-qaa">
                                                <div class="shop-cover image-ctn">
                                                    <img :src="downloadUrl + goods.ShowImg" :onerror="defaultImg" />
                                                </div>
                                                <div class="goods-name" :title="goods.Name">
                                                    {{ goods.GoodsName }}
                                                </div>
                                                <div class="shop-num">x{{ goods.Count }}</div>
                                                <div class="shouh page-link">
                                                    <!-- <span
                            @click="
                              gotoApplyDetails(item, goods.GoodsOrderRsID)
                            "
                            v-if="
                              item.State > 5 &&
                                item.State < 30 &&
                                !goods.IsAfterSale
                            "
                            >申请售后</span
                          > -->
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="div-table-cell order-man">
                                {{ item.Consignee }}
                            </div>
                            <div class="div-table-cell shop-price">
                                <p class="money-value">总金额：￥{{ item.SurplusMoney }}</p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <p class="money-value">{{ item.StateName }}</p>
                                <p @click="gotoDetail(item.OrderId)" class="page-link">
                                    {{ permission.see }}
                                </p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <template>
                                    <p>
                                        <el-button size="small" type="text" @click="gotoPay(item.Osn)" v-if="item.OrderState == 20 && permission.pay">{{
                                            permission.pay
                                        }}</el-button>
                                    </p>
                                    <p>
                                        <el-button size="small" type="text" @click="receiveGoods(item.OrderId)" v-if="item.OrderState == 100 && permission.confirmReceipt">{{
                                            permission.confirmReceipt
                                        }}</el-button>
                                    </p>
                                    <p>
                                        <el-button size="small" type="text" @click="buyAgain(item)" v-if="item.OrderState == 120 && permission.buyAgain">{{
                                            permission.buyAgain
                                        }}</el-button>
                                    </p>
                                    <p>
                                        <el-button size="small" type="text" @click="showCancelOrder(item.OrderId)" v-if="item.OrderState == 20 && permission.cancel">{{
                                            permission.cancel
                                        }}</el-button>
                                    </p>
                                    <!-- <template v-if="item.OrderState == 120">
                    <p v-if="item.IsInvoiced">
                      <el-button
                        size="small"
                        type="text"
                        @click="gotoInvoice(item.OrderId)"
                        v-if="permission.seeInvoice"
                        >{{ permission.seeInvoice }}</el-button
                      >
                    </p>
                    <p v-else>
                      <el-button
                        size="small"
                        type="text"
                        @click="showInvoice(item.OrderId)"
                        v-if="permission.invoicing"
                        >{{ permission.invoicing }}</el-button
                      >
                    </p>
                  </template> -->
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="no-data" v-if="tableDataLength == 0">暂无数据</div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            >
            </el-pagination>
        </div>
        <!--   发票     -->
        <el-dialog :close-on-click-modal="false" width="800px" title="开发票" :visible.sync="invoiceShow" :before-close="handleClose" append-to-body>
            <invoice ref="invoice" :orderId="invoiceOrderId" @closeInvoice="closeInvoice"> </invoice>
        </el-dialog>
        <!--   取消订单     -->
        <el-dialog :close-on-click-modal="false" width="800px" title="取消订单" :visible.sync="cancelOrderShow" :before-close="cancelHandleClose" append-to-body>
            <cancelOrder @closeCancel="closeCancel" :cancelId="cancelId" ref="cancelOrder"> </cancelOrder>
        </el-dialog>
    </div>
</template>
<script>
import cancelOrder from '@/views/business/shareInventory/cancelOrder';
import invoice from '@/components/common/invoice';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        cancelOrder,
        invoice
    },
    props: {},
    data() {
        return {
            cancelId: '',
            cancelOrderShow: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            invoiceOrderId: '',
            invoiceShow: false,
            orderList: [],
            tableDataLength: 0,
            noData: false,
            searchData: {
                entpId: this.$util.getLocalStorage('userMsg').EntpId,
                State: -1,
                Page: 1,
                limit: 15
            },
            permission: {}
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('shareInventoryPurchaseOrders');

        this.getTableData();
    },
    methods: {
        // 跳转发票详情
        gotoInvoice(OrderId) {
            this.$router.push('/goods/invoiceDetails?OrderId=' + OrderId);
        },
        // 显示开发票页面
        showInvoice(id) {
            this.invoiceOrderId = id;
            this.invoiceShow = true;
        },
        gotoApplyDetails(item, OrderGoodRId) {
            if (!item.DetailList) {
                this.$util.warningMsg('该订单没有可申请售后的商品');
                return;
            }
            // this.$router.push(
            //   `/business/service/afterApplyDetails?OrderType=5&OrderId=${
            //     item.OrderId
            //   }&OrderCode=${item.OrderCode}&OrderGoodRId=${
            //     OrderGoodRId ? OrderGoodRId : ""
            //   }`
            // );
        },
        gotoComment(id, type) {
            this.$router.push({
                path: '/shop/comment',
                query: { OrderId: id, type: type }
            });
        },
        // 确认收货
        receiveGoods(_orderId) {
            let that = this;
            this.$util.elConfirm({
                content: '您确定要确认收货吗？',
                confirmMsg: '确认收货成功',
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/ShareInventory/ConfirmOrderReceipt?orderId=' + _orderId
                        })
                        .then(() => {
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 关闭取消订单
        cancelHandleClose() {
            this.$refs.cancelOrder.resetFrom();
            this.cancelOrderShow = false;
        },
        closeCancel() {
            this.cancelOrderShow = false;
            this.getTableData();
        },
        // 去付款
        gotoPay(osn) {
            this.$router.push({
                path: '/shareInventory/pay',
                query: { osn: osn }
            });
        },
        // 取消订单
        showCancelOrder(id) {
            this.cancelId = id;
            this.cancelOrderShow = true;
        },
        // 再次购买
        buyAgain(item) {
            this.$router.push({
                path: '/shareInventory/siOrderConfirm',
                query: { goodsId: item.GoodsList[0].GoodsId, buyQuantity: 1 }
            });
        },
        // 跳转订单详情
        gotoDetail(id) {
            this.$router.push({
                path: '/shareInventory/siPurchaseOrderDetails',
                query: { OrderId: id }
            });
        },
        closeInvoice() {
            this.invoiceShow = false;
        },
        handleClose() {
            this.$refs.invoice.clearData();
            this.invoiceShow = false;
        },
        // 获取数据
        getTableData(type) {
            if (type != undefined && type != null) {
                //为0可以通过,只需要判断不为null
                if (this.searchData.State != type) {
                    this.searchData.Page = 1;
                }
                this.searchData.State = type;
            }
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetSGoodsPurchaseOrderList',
                    data: this.searchData,
                    hideLoading: false
                })
                .then(res => {
                    if (res.data) {
                        this.tableDataLength = res.count;
                        this.orderList = res.data;
                    } else {
                        this.orderList = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(err => {});
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.shop-num,
.hg-price {
    width: 30px;
    margin: 0 10px;
}
.goods-ctn-qaa {
    display: flex;
    align-items: center;
    padding: 5px;
}
.suit-ctn {
    flex-grow: 1;
    padding: 10px;
}
.hg-goods-message {
    display: flex;
    flex-grow: 1;
    align-items: center;
}
.suit-gift-image-ctn {
    width: 70px;
    height: 70px;
    overflow: hidden;
    margin-left: 36px;
    img {
        max-width: 70px;
        max-height: 70px;
    }
}
.shop-cover {
    width: 100px;
    height: 100px;
    overflow: hidden;
    img {
        max-width: 100px;
        max-height: 100px;
    }
}
.shouh {
    width: 4em;
}
.goods-name {
    width: 200px;
}
.order-item {
    margin-bottom: 20px;
}
.page-link {
    cursor: pointer;
    color: @theme;
}
.div-table-cell {
    line-height: 36px;
}
.order-num {
    background: @border2Color;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
}
.order-num-children {
    position: relative;
    background: @border4Color;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
}
.order-time {
    margin-right: 60px;
}
.order-msg {
    border-top: 1px solid @border1Color;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    > div {
        flex-grow: 1;
    }
}
.order-man {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.shop-price {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @font3Color;
    .money-value {
        border-bottom: 1px solid @border3Color;
    }
}
.shop-staus {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @font3Color;
}
.gotoDetail {
    cursor: pointer;
}
.no-data {
    font-size: @font-lg;
    color: @font4Color;
    height: 300px;
    line-height: 300px;
    text-align: center;
}
</style>
